import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

declare const ga: Function;

// Declare gTM dataLayer array.
declare global {
  interface window {
    dataLayer: any[];
  }
}

@Injectable()
export class GoogleAnalyticsEventsService {
  constructor() {}

  /**
   * Checks if the GA script was loaded.
   */
  private useGA(): boolean {
    return environment.googleAnalyticsID && typeof ga !== 'undefined';
  }

  /**
   * Checks if the GTM script was loaded.
   */
  private useGTM(): boolean {
    return environment.googleTagManagerID && window['dataLayer'];
  }

  /**
   * Sends the page view to GA.
   * @param  {string} page The path portion of a URL. This value should start with a slash (/) character.
   */
  public sendPageView(page: string, source: string, variant: string = '') {
    if (this.useGA() || this.useGTM()) {
      if (!page.startsWith('/')) {
        page = `/${page}`;
      }

      if (this.useGA()) {
        if (variant) {
          ga('send', 'pageview', `/${source}/${page} - ${variant}`);
        } else {
          ga('send', 'pageview', '/' + source + '/' + page);
        }
      }

      if (this.useGTM()) {
        window['dataLayer'].push({
          event: '',
          variant: variant,
          vpv: '/' + source + '/' + page,
        });
      }
    } else {
      return;
    }
  }

  /**
   * Sends the event to GA.
   * @param  {string} eventCategory Typically the object that was interacted with (e.g. 'Video')
   * @param  {string} eventAction The type of interaction (e.g. 'play')
   */
  public sendEvent(eventCategory: string, eventAction: string, eventLabel: string, variant: string = '') {
    if (!this.useGA() && !this.useGTM()) {
      return;
    }

    if (this.useGA()) {
      if (variant) {
        ga('send', 'event', eventCategory, `${eventAction} - ${variant}`, eventLabel);
      } else {
        ga('send', 'event', eventCategory, eventAction, eventLabel);
      }
    }

    if (this.useGTM()) {
      window['dataLayer'].push({
        event: eventAction,
        variant: variant,
        vpv: '/' + eventLabel + '/' + eventCategory,
      });
    }
  }
}
